// Generic helpers for head-to-head props (Tennis, Cricket, etc.)

export function extractSurnamesFromTitle(title: string): { p1: string; p2: string } | null {
  if (!title) return null;
  const parts = title.split(/\svs\.?\s/i);
  if (parts.length !== 2) return null;
  const getSurname = (full: string) => {
    const tokens = full.trim().split(/\s+/);
    if (tokens.length === 0) return '';
    return tokens[tokens.length - 1];
  };
  const p1 = getSurname(parts[0]);
  const p2 = getSurname(parts[1]);
  if (!p1 || !p2) return null;
  return { p1, p2 };
}

export function extractSidesFromTitle(title: string): { p1: string; p2: string } | null {
  if (!title) return null;
  const parts = title.split(/\svs\.?\s/i);
  if (parts.length !== 2) return null;
  return { p1: parts[0].trim(), p2: parts[1].trim() };
}

export function stripTournamentPrefix(side: string): string {
  return side.replace(/^.*?:\s*/, '').trim();
}

export function extractCricketSidesFromTitle(title: string): { p1: string; p2: string } | null {
  const sides = extractSidesFromTitle(title);
  if (!sides) return null;
  return { p1: stripTournamentPrefix(sides.p1), p2: stripTournamentPrefix(sides.p2) };
}


